export default __webpack_public_path__ + "3e1eb932bdbaa2318584813bf468be53.svg";